import React from 'react';
import './App.css';

import'bootstrap/dist/css/bootstrap.min.css';
import {  Route, BrowserRouter as Router} from "react-router-dom";
 import Registration from './component/Registration';
 import Otpcomfirm from './component/Otpcomfirm';
 import FormProfile from './component/FormProfile';
 import Login from './component/Login';
 import ForgotPassword from './component/ForgotPassword';
 import Payment from './component/payment';
 import PaymentSuccess from './component/PaymentSuccess';
// import PaymentStatic from './component/PaymentStatic';
 import Guidlines from './component/Guidlines';
 import TermsAndCondition from './component/LevaTermsAndCondition';
 //import Payment from './component/payment';
 import PaymentSuccesssixty from './component/PaymentSuccesssixty';

 import AdminProfile from './component/AdminProfile';
import admin_login from './component/admin_login';
//import FirstHome from './component/FirstHome';
import Nondani from './component/Nondani';
import RegistrationForm from './component/RegistrationForm';
////import PaymentSuccesseventwenty from './component/PaymentSuccesseventwenty';
//import PaymentOneTwenty from './component/PaymentOneTwenty';

// import RulesandRegulations from "./component/RulesandRegulations";
// import termsAndConditions from "./component/termsAndConditions";
// import Refund from "./component/Refund";
// import PrivacyPolicy from "./component/PrivacyPolicy";
// import AboutUS from './component/AboutUS';
class App extends React.Component{


  render(){
  return (
   <>
      <Router basename={"/pustak_suchi"}>
      {/* <Route path={`/`} component={FirstHome} exact/> */}
          <Route path={`/`} component={Registration} exact/>
          <Route path={`/Otpcomfirm` }component={Otpcomfirm} exact/>
          <Route path={`/Login`} component={Login} exact/>
          <Route path={`/ForgotPassword`} component={ForgotPassword} exact/>

          <Route path={`/FormProfile`} component={FormProfile} />
          <Route path={`/AdminProfile`} component={AdminProfile} />
        
          <Route path={`/Payment`} component={Payment} />
           <Route path={`/PaymentSuccess`} component={PaymentSuccess} />
           <Route path={`/PaymentSuccesssixty`} component={PaymentSuccesssixty} />
         <Route path={`/Guidelines`} component={Guidlines}/>
         <Route path={`/TermsAndCondition`} component={TermsAndCondition}/> 
         <Route path={`/Nondani`} component={Nondani}/> 
         <Route path={`/RegistrationForm`} component={RegistrationForm}/> 
         
         {/* <Route path={`/AboutUS`} component={AboutUS}/>  */}
         <Route path={`/Admin`} component={admin_login}/>
         
         {/* <Route
            path={`/rulesandregulations`}
            component={RulesandRegulations}
            exact
          />
          <Route
            path={`/termsandconditions`}
            component={termsAndConditions}
            exact
          />
          <Route path={`/refund`} component={Refund} exact />
          <Route path={`/privacyandpolicy`} component={PrivacyPolicy} exact /> */}
        </Router>
      
      {/* <Switch>
      {/* <Router basename={'/suchi'}> }
          <Route path="/" component={Registration} exact/>
          <Route path="/Otpcomfirm" component={Otpcomfirm} exact/>
          <Route path="/Login" component={Login} exact/>
          <Route path="/ForgotPassword" component={ForgotPassword} exact/>
          <Route path="/FormProfile" component={FormProfile} />
          <Route path="/PaymentStatic" component={PaymentStatic} />
         <Route path="/Guidelines" component={Guidlines}/>
        {/* </Router> }
      </Switch> */}
     
   </>
  );
  }
}

export default App;
